import { useState, useEffect } from "react";

export default function useCallinStatus(statusId) {
  const [callinStatuses, setCallinStatuses] = useState([]);
  const [currentStatus, setCurrentStatus] = useState({});

  const allStatuses = [
    {
      id: "ATDELVRY",
      name: "At Consignee",
      color: "success.80",
      backgroundColor: "success.10"
    },
    {
      id: "ATSHIPR",
      name: "At Shipper",
      color: "success.80",
      backgroundColor: "success.10"
    },
    {
      id: "CONSDLAY",
      name: "Delay at Receiver",
      color: "error.80",
      backgroundColor: "error.10"
    },
    {
      id: "SHIPDLAY",
      name: "Delay at Shipper",
      color: "error.80",
      backgroundColor: "error.10"
    },
    {
      id: "DISPATCH",
      name: "En Route to Shipper",
      color: "success.80",
      backgroundColor: "success.10"
    },
    {
      id: "DLY2SHIP",
      name: "Delay en Route to Shipper",
      color: "error.80",
      backgroundColor: "error.10"
    },
    {
      id: "DOTBREAK",
      name: "Dot Break",
      color: "primary.80",
      backgroundColor: "primary.10"
    },
    {
      id: "DRVRDNA",
      name: "Unable to Reach Driver",
      color: "error.80",
      backgroundColor: "error.10"
    },
    {
      id: "ITDELAY",
      name: "Transit Delay",
      color: "error.80",
      backgroundColor: "error.10"
    },
    {
      id: "MOVING",
      name: "In Progress",
      color: "success.80",
      backgroundColor: "success.10"
    },
    {
      id: "PREVIOUS",
      name: "Driver at Previous",
      color: "warning.80",
      backgroundColor: "warning.10"
    },
    {
      id: "PREPLAN",
      name: "Driver Not at Previous",
      color: "warning.80",
      backgroundColor: "warning.10"
    },
  ];

  useEffect(() => {
    setCallinStatuses(allStatuses);
  }, []);

  useEffect(() => {
    const index = callinStatuses.findIndex(status => status.id === statusId);
    setCurrentStatus(callinStatuses[index]);
  }, [statusId, callinStatuses]);

  return { callinStatuses, currentStatus };
}